<template>
  <span class="n-icon">
    <svg viewBox="0 0 24 24" :fill="fill">
      <path fill="currentColor" d="M16,18H18V6H16M6,18L14.5,12L6,6V18Z" />
    </svg>
  </span>
</template>

<script lang="ts" setup>
defineProps({
  fill: {
    type: String,
    default: 'currentColor',
  },
});

defineOptions({
  name: 'n-skip-next-icon',
});
</script>
